import { api } from '@core/api/apiClient';

interface CreateReviewResponse {
  review_id: string;
}

/**
 * Create a review record for a reservation.
 * Called on page mount to get a reviewId for subsequent updates.
 */
export async function createReview(resId: string): Promise<string> {
  const data = await api.post<CreateReviewResponse>('/api/review/create', {
    id: resId,
    face: undefined,
  });
  return data.review_id;
}

/**
 * Update a single review parameter (one question at a time).
 * Params: 'rating' | 'message' | 'service' | 'atmosphere' | 'food' | 'drinks' | 'expectations' | 'returnIntent'
 */
export async function updateReview(
  reviewId: string,
  param: string,
  value: string | number
): Promise<void> {
  await api.post('/api/review/update-new', {
    id: reviewId,
    param,
    value,
  });
}
